import React, {
  Component
} from 'react'
import {
  List,
  Radio,
  NavBar,
  SearchBar
} from 'antd-mobile'
import send from '../../../utils/send_init'
import {
  ROOT_PATH
} from '../../../config'
import AutoRefresh from '../../../components/autoRefresh';
let page = 1;
let queryValue = '';
class OrgCodeList extends Component {
  constructor(props) {
    super(props);
    // 用于交互数据
    this.state = {
      refreshing: false,
      down: false,
      // 导航高度: 45, 搜索高度: 44, 子项名: 45
      height: window.HEIGHT - 78,
      modalData: [],
      sumCount: 0,
      size: 20
    }
  }
  getData = () => {
    const {sex} = this.props;
    send({
      'url': `${ROOT_PATH}/api/ifarm/v1/genealogy/dam_sir_track`,
      'method': 'POST',
      'data': {
        'sex': sex,
        'page': {
          'currentPage': page,
          'size': this.state.size
        },
        'queryValue': queryValue
      }
    }).then(res => {
      console.log(res.data);
      this.setState(state => {
        state.sumCount = res.data.sumCount;
        state.refreshing = false;
        page === 1 ?
          state.modalData = res.data.list :
          state.modalData = state.modalData.concat(res.data.list);
        return Object.assign({}, state)
      })
    }).catch(err => {
      console.log(err);
    })
  };

  getNextPageData = () => {
    console.log(this.state.sumCount, this.state.modalData.length);
    if (this.state.sumCount >= this.state.modalData.length) {
      page++;
      this.getData(page);
      this.setState({
        refreshing: true
      });
    }
  };
  doSearch = (v) => {
    queryValue = v;
    page = 1;
    this.setState({
      sumCount: 0,
      sumPage: 0
    });
    this.getData(1);
  };
  componentDidMount() {
    queryValue='';
    if (this.state.modalData.length === 0) {
      page = 1;
      this.getData(1)
    }
  }
  componentWillUnmount() {
    this.setState = (state, callback) => {

    };
  }
  render() {
    const {current, id} = this.props;
    return (
      <React.Fragment>
        <NavBar mode="light">猪只列表</NavBar>
        <SearchBar
            placeholder="搜索"
            onChange={v => this.doSearch(v)}
            onClear={v => this.doSearch(v)}
        />
        <List>
          <AutoRefresh
              damping={60}
              style={{
              height: this.state.height,
              overflow: 'auto'
            }}
              indicator={this.state.down ? {deactivate : '下拉可以刷新'} : { deactivate: '上拉可以刷新' }}
              direction={this.state.down ? 'down' : 'up'}
              refreshing={this.state.refreshing}
              onRefresh={this.getNextPageData}
              top={90}
              size={this.state.modalData.length}
              total={this.state.sumCount}
          >
            {this.state.modalData.map((item, index) =>
              <Radio.RadioItem
                  key={index}
                  indicator={{ deactivate: '上拉可以刷新' }}
                  direction={'up'}
                  checked={current === (item.swineTrack + item.swineDateIn)}
                  onClick={() => this.props.selectItem(item,id)}
              >
                <List.Item.Brief>
                  母猪耳号：{item.swineId}
                </List.Item.Brief>
                <List.Item.Brief>
                  母猪详情编码：{item.swineTrack}
                </List.Item.Brief>
               {/* <List.Item.Brief>
                  状态：{item.activityType}
                </List.Item.Brief>
                <List.Item.Brief>
                  状态日期：{df(item.activityDate, 'yyyy-mm-dd')}
                </List.Item.Brief>*/}
              </Radio.RadioItem>
            )}
          </AutoRefresh>
        </List>
      </React.Fragment>
    )
  }
}
export default OrgCodeList
